module.exports = __webpack_public_path__ + "img/carrousel-video-13.63c90447.png";